import { Cancel, Edit, Set } from './components';

const AutomatedOrdersConfirmationFlow = {
  Set,
  Edit,
  Cancel,
};

export { AutomatedOrdersConfirmationFlow };
